document.querySelectorAll('.js--accordion-trigger').forEach(header => {
    header.addEventListener('click', () => {
        const item = header.parentElement;
        const isExpanded = header.getAttribute('aria-expanded') === 'true';

        // 状態の反転
        header.setAttribute('aria-expanded', !isExpanded);
        item.querySelector('.js--accordion-content').setAttribute('aria-hidden', isExpanded);
        item.classList.toggle('is-active');
    });
});


/* フォーマット例

<div class="accordion">
    <button class="accordion__trigger js--accordion-trigger" aria-expanded="false" aria-controls="content-1">タイトル</button>
    <div id="content-1" class="accordion__content js--accordion-content" aria-hidden="true">
        <div class="accordion__inner">
            コンテンツ
        </div>
    </div>
</div>

*/